<template>
  <a-modal
    v-model:visible="props.visible"
    width="600px"
    @cancel="closePopup(false)"
    :footer="null"
    :mask-closable="false"
  >
    <a-row>
      <a-col :span="24">
        <a-form :model="formData" ref="formRef">
          <InputSlot
            :label="$t('discharge_business_operator')"
            inputId="dischargerId"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
            required
          >
            <a-form-item
              ref="dischargerId"
              name="dischargerId"
              :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]"
            >
              <a-select
                v-model:value="formData.dischargerId"
                style="width: 100%"
                :disabled="selectedCompanyId !== 'ALL'"
              >
                <a-select-option
                  v-for="(item, index) in listCompany"
                  :key="index"
                  :value="item.value"
                >
                  <span style="white-space: normal; word-wrap: break-word">{{ item.label }}</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('project_title')"
            inputId="projectId"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
            required
          >
            <a-form-item
              ref="projectId"
              name="projectId"
              :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]"
            >
              <a-select
                v-model:value="formData.projectId"
                @change="onChangeProjectTitle"
                style="width: 100%"
                :disabled="formData.dischargerId === null"
              >
                <a-select-option
                  v-for="(item, index) in listProjectTitle"
                  :key="index"
                  :value="item.id"
                >
                  <span style="white-space: normal; word-wrap: break-word">{{
                    item.projectTitle
                  }}</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('collection_date')"
            inputId="collectionDate"
            required
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item
              ref="collectTime"
              name="collectTime"
              :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]"
            >
              <a-select
                v-model:value="formData.collectTime"
                :disabled="formData.projectId === null"
                @change="onChangeCollectionDate"
              >
                <a-select-option
                  v-for="(item, index) in listCollectTime"
                  :key="index"
                  :value="item.collectionTime"
                  >{{ getCollectTimeLabel(item.collectionTime) }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('waste_name')"
            inputId="wasteName"
            required
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item
              ref="wasteId"
              name="wasteId"
              :rules="[{ required: true, message: t('MSG_00_21'), trigger: ['blur', 'change'] }]"
            >
              <a-select
                v-model:value="selectedWasteIndex"
                :disabled="formData.projectId === null || formData.collectTime === null"
                @change="onChangeWaste"
              >
                <a-select-option v-for="(item, index) in listWasteName" :key="index" :value="index">
                  <span style="white-space: normal; word-wrap: break-word">{{ item.name }}</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('manifest_number')"
            inputId="manifestNumber"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 10 }"
          >
            <a-row :gutter="{ xs: 8, sm: 10 }" style="padding-top: 5px; height: 54px">
              <a-col>
                <span>{{ formData.manifestId }}</span>
              </a-col>
            </a-row>
          </InputSlot>
          <InputSlot
            :label="$t('transportation_end_date')"
            inputId="transportationEndDate"
            required
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item
              name="transportation_end_date"
              :rules="[{ validator: validateDate, trigger: ['blur', 'change'] }]"
            >
              <a-date-picker
                v-model:value="formData.transportEndDate"
                placeholder="YYYY/MM/DD"
                :format="'YYYY/MM/DD'"
                @change="onChangeTransportEndDate"
                :disabled-date="disableCollectionDate"
                :disabled="
                  formData.projectId === null ||
                  formData.wasteId === null ||
                  formData.collectTime === null
                "
              />
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('transport_volume')"
            inputId="transportVolume"
            required
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-row :gutter="{ xs: 8, sm: 10 }">
              <a-col id="transport_volume" :xs="18" :sm="14" :md="8" :lg="10">
                <a-form-item
                  name="transport_volume"
                  :rules="[{ validator: validateTransportVolume, trigger: ['blur', 'change'] }]"
                >
                  <VolumeInput
                    data-jwnet-exempt
                    v-model:value="formData.transportVolume"
                    class="input-right"
                    :disabled="isDisableInput()"
                  />
                </a-form-item>
              </a-col>
              <a-col
                id="transport_volume_unit"
                :xs="6"
                :sm="6"
                :md="8"
                :lg="8"
                class="field-v-center"
              >
                <a-form-item name="transport_volume_unit">
                  <a-select
                    v-model:value="formData.transportVolumeUnit"
                    style="width: 100%"
                    :disabled="isDisableInput()"
                  >
                    <a-select-option
                      v-for="(item, index) in listMeasureUnit"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.unit }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row style="color: #ff4d4f; height: 22px">
              <span v-if="!transportVolumeValid">{{ t('MSG_00_27') }}</span>
            </a-row>
          </InputSlot>
          <InputSlot
            :label="$t('valuables_collected')"
            inputId="valuablesCollected"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-row :gutter="{ xs: 8, sm: 10 }">
              <a-col id="valuables_collected" :xs="18" :sm="14" :md="8" :lg="10">
                <a-form-item
                  name="valuables_collected"
                  :rules="[{ validator: validateValuablesCollected, trigger: ['blur', 'change'] }]"
                >
                  <VolumeInput
                    data-jwnet-exempt
                    v-model:value="formData.valuablesCollected"
                    class="input-right"
                    :disabled="isDisableInput() || disableValuablesCollected()"
                  />
                </a-form-item>
              </a-col>
              <a-col
                id="valuables_collected_unit"
                :xs="6"
                :sm="6"
                :md="8"
                :lg="8"
                class="field-v-center"
              >
                <a-form-item name="valuables_collected_unit">
                  <a-select
                    v-model:value="formData.valuablesCollectedUnit"
                    style="width: 100%"
                    :disabled="isDisableInput()"
                    @change="onChangeValuablesCollected"
                  >
                    <a-select-option
                      v-for="(item, index) in listMeasureUnit"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.unit }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row style="color: #ff4d4f; height: 22px">
              <span v-if="!valuablesCollectedValid">{{ t('MSG_00_27') }}</span>
            </a-row>
          </InputSlot>
          <InputSlot
            :label="$t('vehicle_number')"
            inputId="vehicleNumber"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item name="vehicle_number">
              <a-input
                v-model:value="formData.vehicleNumber"
                :data-jwnet-value="formData.vehicleNumber"
                maxlength="30"
                :disabled="isDisableInput()"
              />
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('reporter')"
            inputId="reporter"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item>
              <a-input
                v-model:value="formData.reporter"
                :data-jwnet-value="formData.reporter"
                style="width: 100%"
                maxlength="24"
                :disabled="isDisableInput()"
              />
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('transporter')"
            inputId="transporter"
            required
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item
              ref="transporter"
              name="transporter"
              :rules="[{ required: true, message: t('MSG_00_21'), trigger: 'blur' }]"
            >
              <a-input
                v-model:value="formData.transporter"
                :data-jwnet-value="formData.transporter"
                style="width: 100%"
                maxlength="24"
                :disabled="isDisableInput()"
              />
            </a-form-item>
          </InputSlot>
          <InputSlot
            :label="$t('disposal_method')"
            inputId="disposalMethodId"
            :labelSpan="{ xs: 24, sm: 6 }"
            :inputSpan="{ xs: 24, sm: 18 }"
          >
            <a-form-item ref="disposalMethodId" name="disposalMethodId">
              <a-select
                v-model:value="formData.disposalMethodId"
                style="width: 100%"
                :disabled="isDisableInput()"
                show-search
                :filter-option="searchDisposalMethod"
                :allow-clear="true"
              >
                <a-select-option
                  v-for="(item, index) in listDisposalMethod"
                  :key="item.method"
                  :value="item.id"
                >
                  <span style="white-space: normal; word-wrap: break-word">{{ item.method }}</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </InputSlot>
          <a-form-item>
            <a-row>
              <a-col :xs="24" :sm="24" :md="24" :lg="24" class="bottom">
                <a-form-item>
                  <a-button
                    type="primary"
                    @click="report"
                    :disabled="isDisableReport() || isSubmitting || isConfirmVisible"
                    :loading="isSubmitting"
                    >{{ $t('report') }}</a-button
                  >
                </a-form-item>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <template #title>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="24" class="header">
          <span>{{ $t('report_complete_transport_industry_waste') }}</span>
        </a-col>
      </a-row>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import InputSlot from '../components/InputSlot.vue';
import { useI18n } from 'vue-i18n';
import { Modal, message } from 'ant-design-vue';
import type { Rule } from 'ant-design-vue/es/form';
import AchievementService from '@/services/modules/AchievementService';
import dayjs, { Dayjs } from 'dayjs';
import { PROJECT } from '@/constants';
import { useCommonStore } from '@/stores';
import { storeToRefs } from 'pinia';
import { formatModalTitle } from '@/utils/modules/message';
import VolumeInput from './VolumeInput.vue';
import { useJwnetValidation } from '@/utils/useJwnetValidation';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close']);

interface FormData {
  dischargerId: number | null;
  projectId: string | null;
  collectTime: string | null;
  wasteId: string | null;
  transportEndDate: Dayjs | null;
  endDateTransportation: string | null;
  manifestId: string | null;
  vehicleNumber: string;
  transportVolume: string;
  transportVolumeUnit: number | null;
  valuablesCollected: string;
  valuablesCollectedUnit: number | null;
  reporter: string;
  transporter: string;
  disposalMethodId: number | null;
}

const formData = ref<FormData>({
  dischargerId: null,
  projectId: null,
  collectTime: null,
  wasteId: null,
  transportEndDate: null,
  endDateTransportation: null,
  manifestId: null,
  vehicleNumber: '',
  transportVolume: '0.00',
  transportVolumeUnit: null,
  valuablesCollected: '0.00',
  valuablesCollectedUnit: null,
  reporter: '',
  transporter: '',
  disposalMethodId: null
});

const listCompany = ref<any[]>([]);
const listProjectTitle = ref<any[]>([]);
const listCollectTime = ref<any[]>();
const listWasteName = ref<any[]>([]);
const listMeasureUnit = ref<any[]>([]);
const listDisposalMethod = ref<any[]>([]);
const transportVolumeValid = ref();
const valuablesCollectedValid = ref();
const isSubmitting = ref(false);
const isConfirmVisible = ref(false);
const { t } = useI18n();
const formRef = ref();
const { validateBeforeSubmit, clearErrors } = useJwnetValidation(formRef);
const commonStore = useCommonStore();
const { selectedCompanyId } = storeToRefs(commonStore);
const selectedWasteIndex = ref();

onMounted(() => {
  transportVolumeValid.value = true;
  valuablesCollectedValid.value = true;
});

watch(
  () => props.visible,
  async (val) => {
    if (val) {
      if (selectedCompanyId.value == 'ALL') {
        listCompany.value = await AchievementService.getListCompanyForReport(
          PROJECT.TYPE.INDUSTRIAL
        );
      } else if (selectedCompanyId.value != null) {
        formData.value.dischargerId = Number.parseInt(selectedCompanyId.value);
        listProjectTitle.value = await AchievementService.getListProjectTitle(
          PROJECT.TYPE.INDUSTRIAL,
          selectedCompanyId.value
        );
        listCompany.value = commonStore.companyList;
      }
      listMeasureUnit.value = await AchievementService.getListMeasureUnit();
      listDisposalMethod.value = await AchievementService.getListDisposalMethod();
    }
  }
);

watch(
  () => formData.value.dischargerId,
  async (val) => {
    listProjectTitle.value = await AchievementService.getListProjectTitle(
      PROJECT.TYPE.INDUSTRIAL,
      formData.value.dischargerId?.toString()
    );
    formData.value.projectId = null;
    formData.value.collectTime = null;
    selectedWasteIndex.value = null;
    formData.value.wasteId = null;
    formData.value.transportEndDate = null;
    formData.value.manifestId = null;
    formData.value.transportVolumeUnit = null;
    formData.value.valuablesCollectedUnit = null;
    resetInput();
    formRef.value.clearValidate();
  }
);

const onChangeProjectTitle = async (value: any) => {
  if (value != null) {
    let response = await AchievementService.getCollectionDateIndustry(formData.value.projectId);
    listCollectTime.value = [];
    response.forEach((value: string) => {
      if (value.includes(t('wave_dash_character'))) {
        let collectionTimes = value.split(t('wave_dash_character'));
        let startDate = dayjs(collectionTimes[0].trim(), 'YYYY-MM-DD HH:mm:ss').format(
          'YYYY/MM/DD HH:mm'
        );
        let endDate = dayjs(collectionTimes[1].trim(), 'YYYY-MM-DD HH:mm:ss').format(
          'YYYY/MM/DD HH:mm'
        );
        let collectionTime = startDate + ' ' + t('wave_dash_character') + ' ' + endDate;
        listCollectTime.value?.push({
          collectionTime: collectionTime
        });
      } else {
        listCollectTime.value?.push({
          collectionTime: value.replace(/-/g, '/')
        });
      }
    });
  }
  selectedWasteIndex.value = null;
  formData.value.wasteId = null;
  formData.value.collectTime = null;
  formData.value.transportEndDate = null;
  formData.value.manifestId = null;
  formData.value.transportVolumeUnit = null;
  formData.value.valuablesCollectedUnit = null;
  resetInput();
  formRef.value.clearValidate();
};

const onChangeWaste = (value: any, option: any) => {
  let waste = listWasteName.value?.[value];
  formData.value.wasteId = waste?.id;
  formData.value.manifestId = waste?.manifestId;
  formData.value.transportEndDate = null;
  formData.value.transportVolumeUnit = waste?.unit;
  formData.value.valuablesCollectedUnit = waste?.unit;
  resetInput();
  formRef.value.clearValidate();
};

const onChangeCollectionDate = async (value: any) => {
  let collectionDate = value.includes(t('wave_dash_character'))
    ? value
    : value + ' 00:00' + t('wave_dash_character') + value + ' 00:00';
  listWasteName.value = await AchievementService.getListWasteName(
    formData.value.projectId,
    collectionDate
  );
  formData.value.manifestId = null;
  selectedWasteIndex.value = null;
  formData.value.wasteId = null;
  formData.value.transportVolumeUnit = null;
  formData.value.valuablesCollectedUnit = null;
};

const getCollectTimeLabel = (collectionTime: string) => {
  return collectionTime.includes(t('wave_dash_character'))
    ? collectionTime
    : collectionTime + '（終日）';
};

const disableCollectionDate = (day: Dayjs) => {
  if (formData.value.collectTime === null) {
    return false;
  }
  if (!formData.value.collectTime.includes(t('wave_dash_character'))) {
    return day.isBefore(dayjs(formData.value.collectTime, 'YYYY-MM-DD').startOf('day'));
  }
  let times = formData.value.collectTime.split(t('wave_dash_character'));
  let endDate = dayjs(times[1].trim(), 'YYYY-MM-DD HH:mm');
  return day.isBefore(endDate.startOf('day')) || day.isAfter(dayjs().endOf('day'));
};

const onChangeTransportEndDate = (date: Dayjs, dateString: string) => {
  formData.value.endDateTransportation = dateString;
};

const isDisableReport = () => {
  const regex = /^\d{1,5}(\.\d{0,2})?$/;
  return (
    !formData.value.projectId ||
    !formData.value.wasteId ||
    !formData.value.collectTime ||
    !formData.value.transportEndDate ||
    !formData.value.transportVolume ||
    !regex.test(formData.value.transportVolume.replace(/,/g, '')) ||
    !formData.value.transporter ||
    formData.value.transporter.trim() === ''
  );
};

const isDisableInput = () => {
  return (
    formData.value.dischargerId === null ||
    formData.value.projectId === null ||
    formData.value.wasteId === null ||
    formData.value.collectTime === null
  );
};

const disableValuablesCollected = () => {
  if (formData.value.valuablesCollectedUnit != null) {
    let unit = listMeasureUnit.value.find(
      (item) => item.id === formData.value.valuablesCollectedUnit
    );
    return unit?.unit === '個・台';
  }
};

const onChangeValuablesCollected = () => {
  if (formData.value.valuablesCollectedUnit != null) {
    let unit = listMeasureUnit.value.find(
      (item) => item.id === formData.value.valuablesCollectedUnit
    );
    if (unit?.unit === '個・台') {
      formData.value.valuablesCollected = '0.00';
    }
  }
};

const resetInput = () => {
  clearErrors();
  formData.value.transportVolume = '0.00';
  formData.value.valuablesCollected = '0.00';
  formData.value.vehicleNumber = '';
  formData.value.reporter = '';
  formData.value.transporter = '';
  formData.value.disposalMethodId = null;
  transportVolumeValid.value = true;
  valuablesCollectedValid.value = true;
};

const report = async () => {
  if (isSubmitting.value || isConfirmVisible.value) {
    return;
  }

  try {
    if (!(await validateBeforeSubmit())) return;
    isConfirmVisible.value = true;

    let modal: any;
    const handleConfirm = async () => {
      if (isSubmitting.value) {
        return;
      }

      isSubmitting.value = true;
      modal.update({
        cancelButtonProps: {
          type: 'primary',
          loading: true,
          disabled: true,
          onClick: handleConfirm
        },
        okButtonProps: {
          disabled: true
        }
      });

      try {
        if (formData.value.transportVolume) {
          formData.value.transportVolume = formData.value.transportVolume.replaceAll(',', '');
        }
        if (formData.value.valuablesCollected) {
          formData.value.valuablesCollected = formData.value.valuablesCollected.replaceAll(',', '');
        }

        await AchievementService.reportCompleteTransportIndustryWaste(formData.value);

        message.success({
          content: t('message_add_report_transport_industry_waste_success'),
          duration: 5
        });
        closePopup(true);
        modal.destroy();
      } catch (error: any) {
        message.error({
          content: t('message_add_report_transport_industry_waste_fail'),
          duration: 5
        });
      } finally {
        isSubmitting.value = false;
        if (isConfirmVisible.value) {
          modal.update({
            cancelButtonProps: {
              type: 'primary',
              loading: false,
              disabled: false,
              onClick: handleConfirm
            },
            okButtonProps: {
              disabled: false
            }
          });
        }
      }
    };

    modal = Modal.confirm({
      title: '',
      cancelText: t('yes'),
      cancelButtonProps: {
        type: 'primary',
        onClick: handleConfirm
      },
      okText: t('no'),
      okType: 'danger',
      centered: true,
      maskClosable: true,
      afterClose() {
        isConfirmVisible.value = false;
      },
      onOk() {
        modal.destroy();
      }
    });
    const title = t('MSG_20_1');
    modal.update({
      title: formatModalTitle(title)
    });
  } catch (error) {
    isConfirmVisible.value = false;
  }
};

const closePopup = (needUpdate: boolean | null) => {
  clearErrors();
  isSubmitting.value = false;
  isConfirmVisible.value = false;
  emit('close', needUpdate);
  formData.value = {
    dischargerId: null,
    projectId: null,
    collectTime: null,
    wasteId: '',
    transportEndDate: null,
    endDateTransportation: null,
    manifestId: null,
    vehicleNumber: '',
    transportVolume: '0.00',
    transportVolumeUnit: null,
    valuablesCollected: '0.00',
    valuablesCollectedUnit: null,
    reporter: '',
    transporter: '',
    disposalMethodId: null
  };
  transportVolumeValid.value = true;
  valuablesCollectedValid.value = true;
  formRef.value.resetFields();
};

const validateDate = async (_rule: Rule, value: string) => {
  const regex = /^\d{4}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])$/;
  if (!formData.value.transportEndDate) {
    return Promise.reject(t('MSG_00_21'));
  } else {
    return Promise.resolve();
  }
};

const validateTransportVolume = async (_rule: Rule, value: string) => {
  if (AchievementService.validateVolume(formData.value.transportVolume)) {
    transportVolumeValid.value = true;
    return Promise.resolve();
  } else {
    transportVolumeValid.value = false;
    return Promise.reject();
  }
};

const validateValuablesCollected = async (_rule: Rule, value: string) => {
  if (AchievementService.validateVolume(formData.value.valuablesCollected)) {
    valuablesCollectedValid.value = true;
    return Promise.resolve();
  } else {
    valuablesCollectedValid.value = false;
    return Promise.reject();
  }
};

const searchDisposalMethod = (value: string, option: any, record: any) => {
  return option.key.toLowerCase().includes(value.toLowerCase());
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.header {
  text-align: center;
  color: #0083e9;
  font-size: 20px;
  border-bottom: 1px solid $gray-color;
  padding-bottom: 15px;
  margin-bottom: 10px;
}

.bottom {
  text-align: center;
  border-top: 1px solid $gray-color;
  padding-top: 20px;

  button {
    background-color: #4096ff;
    width: 120px;
  }
}

.ant-form-item {
  margin-bottom: 0px;
  height: 54px;
}

#transport_volume .ant-form-item,
#transport_volume_unit .ant-form-item,
#valuables_collected .ant-form-item,
#valuables_collected_unit .ant-form-item {
  height: 32px;
}

input.input-right {
  text-align: right;
}

span.input-right {
  input {
    text-align: right;
  }
}

.field-v-center {
  align-content: center;
}

:deep(span.input-right input) {
  text-align: right;
}
</style>
